import * as PendingOrders from "../../../src/Containers/Telecom/PendingOrders.scss";
import { isNullOrWhiteSpace, split, toFail, printf, toText } from "../../fable_modules/fable-library.3.7.20/String.js";
import * as react from "react";
import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { list_type, bool_type, record_type, lambda_type, class_type, union_type, string_type, unit_type, option_type, int32_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library.3.7.20/Choice.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { useDispatch, useSelector } from "../../Redux/Store.js";
import { GlobalDependencies$reflection, LoadState$2$reflection, SaveStatus$reflection, SaveStatus, getTranslationFrom, LoadState$2 } from "../../Global.js";
import { stripHtmlTags, logii, logwi, DateTimeExtensions_toIso8601, truncateWithEllipsis, logei, DateTimeExtensions_yyyy_MM_ddTHH_mm_ssZ, DateTimeExtensions_toDateHHmm, optToStr, stackClasses, DateTimeExtensions_toDateHHmmss, Locale$reflection, classNames } from "../../Utils.js";
import { isEmpty, cons, append as append_1, fold, sortByDescending, length, empty, map as map_1, filter, collect, singleton as singleton_1, ofArray } from "../../fable_modules/fable-library.3.7.20/List.js";
import { MaterialIcon_render_Z384F8060, Size, getMaterialIconBySize, dotsLoading, LoadingBarProps, renderLoadingBar, getMaterialIcon } from "../../ViewUtils.js";
import { startImmediate } from "../../fable_modules/fable-library.3.7.20/Async.js";
import { singleton } from "../../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { stringHash, equals, int32ToString, uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { value as value_8, defaultArgWith, map, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { addHours, toUniversalTime, compare, month, year, daysInMonth, addYears, addDays, now as now_1, fromDateTimeOffset } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { SelectOption, ValueProp, SelectOption_get_getDefault, selectOption, DateOptions, DateOptions_get_getDefault, inputDate } from "../../Components/FormFields/FormFields.js";
import { TimeTwentyFour, EnableBy, EnableRanges, OnChange, Value, EnableTimePicker, Locale as Locale_1, FormatDateBy, Id as Id_1 } from "../../fable_modules/Fable.React.Flatpickr.3.0.0/Flatpickr.fs.js";
import { Prop, DOMAttr, HTMLAttr } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Props.fs.js";
import { keyValueList } from "../../fable_modules/fable-library.3.7.20/MapUtil.js";
import { renderModal } from "../../Components/Modals/Choice/Choice.js";
import { render as render_1 } from "../../Components/Modals/SaveState/SaveState.js";
import { getModalContainer, modal, getModalBodyContainer, getModalFooterContainer, getModalHeader, ModalSize } from "../../Components/Modal/Modal.js";
import { empty as empty_1, append, singleton as singleton_2, delay, toList } from "../../fable_modules/fable-library.3.7.20/Seq.js";
import { defaultProps, modalMain, ButtonProps, ButtonProps_get_getDefault, ButtonKind, wrappedButton } from "../../Components/Button/Button.js";
import { totalHours, create } from "../../fable_modules/fable-library.3.7.20/TimeSpan.js";
import { NetworkDetails, PendingProvisioningEventsDTO$reflection, OrderDTO$reflection } from "./Model.js";
import { CreateOrderDTO, CreateOrderDTO$reflection } from "../TelecomOrder/Model.js";
import { UTC_ofDateTime_7F9DDECF, UTC$reflection } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { setItem, getItem } from "../../LocalStorage.js";
import { MessageType, renderAsModal } from "../../Components/Modals/InfoMessage/InfoMessage.js";
import { render as render_2 } from "../../Components/Modals/Standard.js";
import { renderCustomTable, renderHeader, Elements_renderCell } from "../../Components/Table/Table.js";
import { createOrder } from "../TelecomOrder/Api.js";
import { saveArchiveOrder, loadPendingProvisioningEvents as loadPendingProvisioningEvents_1, cancelOrder as cancelOrder_1, loadNetworkDetails as loadNetworkDetails_1, updatePendingChangeDate } from "./Api.js";
import { parse } from "../../fable_modules/fable-library.3.7.20/Double.js";
import { PageinationProps$1, Pagination } from "../../Components/Pagination/Pagination.js";
import { error, info } from "../../Components/Message/Message.js";
import { Browser_Types_Event__Event_get_Value } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Extensions.fs.js";
import { loadOperationStatusesThunk } from "../../Api/Telecom.js";
import { Helpers_equalsButFunctions } from "../../fable_modules/Fable.React.7.4.3/Fable.React.Helpers.fs.js";
import { NumberHistory$reflection } from "../Subscriptions/Common.js";
import { List_groupBy } from "../../fable_modules/fable-library.3.7.20/Seq2.js";


function renderLabelContents(label, contents) {
    let children;
    const children_4 = [(children = [toText(printf("%s:"))(label)], react.createElement("span", {
        className: "font-weight-bold",
    }, ...children)), react.createElement("span", {
        className: "ml-2",
    }, contents)];
    return react.createElement("div", {}, ...children_4);
}

export class ArchiveButtonProps extends Record {
    constructor(ClientNr, NetworkContractNr, OrderNr, ArchiveOrder, LoadOrders) {
        super();
        this.ClientNr = (ClientNr | 0);
        this.NetworkContractNr = NetworkContractNr;
        this.OrderNr = (OrderNr | 0);
        this.ArchiveOrder = ArchiveOrder;
        this.LoadOrders = LoadOrders;
    }
}

export function ArchiveButtonProps$reflection() {
    return record_type("Containers.Telecom.PendingOrders.ArchiveButtonProps", [], ArchiveButtonProps, () => [["ClientNr", int32_type], ["NetworkContractNr", option_type(int32_type)], ["OrderNr", int32_type], ["ArchiveOrder", lambda_type(int32_type, lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))))], ["LoadOrders", lambda_type(unit_type, unit_type)]]);
}

const renderArchiveButton = FunctionComponent_Of_Z5A158BBF((props) => {
    let _arg;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const loadingState = react.useState(new LoadState$2(0));
    react.useEffect(() => {
        loadingState[1](new LoadState$2(0));
    }, [props.OrderNr]);
    const classes = classNames(ofArray([["row__archive-btn", true], ["bounce2 ", (_arg = (loadingState[0]), (_arg.tag === 1) ? true : (_arg.tag === 2))], ["row__archive-btn--red", (loadingState[0]).tag === 3]]));
    let title;
    const matchValue = loadingState[0];
    title = ((matchValue.tag === 3) ? matchValue.fields[0] : getTranslationFrom(translationsLoadState, "Common.Archive"));
    const children = [getMaterialIcon("archive")];
    return react.createElement("div", {
        className: classes,
        title: title,
        onClick: (e) => {
            let a;
            e.stopPropagation();
            loadingState[1](new LoadState$2(1));
            const matchValue_1 = props.NetworkContractNr;
            if (matchValue_1 != null) {
                startImmediate((a = props.ArchiveOrder(props.ClientNr, matchValue_1, props.OrderNr), singleton.Delay(() => singleton.Bind(a, (_arg_2) => {
                    let result;
                    return singleton.Return((result = _arg_2, (result.tag === 1) ? (loadingState[1](new LoadState$2(3, result.fields[0]))) : (loadingState[1](new LoadState$2(2, void 0)))));
                }))));
            }
        },
    }, ...children);
}, "ArchiveButton", uncurry(2, void 0), void 0, "renderArchiveButton", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Telecom\\PendingOrders.fs", 83);

export class RenderTruncatedStringProps extends Record {
    constructor(Str, MaxLength) {
        super();
        this.Str = Str;
        this.MaxLength = (MaxLength | 0);
    }
}

export function RenderTruncatedStringProps$reflection() {
    return record_type("Containers.Telecom.PendingOrders.RenderTruncatedStringProps", [], RenderTruncatedStringProps, () => [["Str", string_type], ["MaxLength", int32_type]]);
}

function renderTruncatedString(text, maxLength) {
    return (text.length > maxLength) ? (text.slice(void 0, (maxLength - 1) + 1) + "...") : text;
}

export class OrderStatus extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Pending", "Error", "Success", "Cancelled"];
    }
}

export function OrderStatus$reflection() {
    return union_type("Containers.Telecom.PendingOrders.OrderStatus", [], OrderStatus, () => [[], [["Item1", class_type("System.DateTime")], ["Item2", string_type]], [["Item", class_type("System.DateTime")]], [["Item", class_type("System.DateTime")]]]);
}

export function OrderStatus_GetStatus_6887C0F8(order) {
    const matchValue = [order.SuccessDate, order.CancelledDate, order.ErrorDate];
    if (matchValue[0] != null) {
        return new OrderStatus(2, matchValue[0]);
    }
    else if (matchValue[1] != null) {
        return new OrderStatus(3, matchValue[1]);
    }
    else if (matchValue[2] != null) {
        return new OrderStatus(1, matchValue[2], defaultArg(order.ErrorString, ""));
    }
    else {
        return new OrderStatus(0);
    }
}

export function OrderStatus_get_GetMaterialIcon() {
    return (_arg) => ((_arg.tag === 3) ? "block" : ((_arg.tag === 1) ? "close" : ((_arg.tag === 2) ? "done" : "pending_actions")));
}

export function OrderStatus_GetTitle_11D407F6(getTranslation) {
    return (_arg) => ((_arg.tag === 3) ? getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.Cancelled") : ((_arg.tag === 1) ? getTranslation("Common.Error") : ((_arg.tag === 2) ? getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.Done") : getTranslation("Common.Pending"))));
}

export class NetworkQueryType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Order", "PendingProvisioningEvent"];
    }
}

export function NetworkQueryType$reflection() {
    return union_type("Containers.Telecom.PendingOrders.NetworkQueryType", [], NetworkQueryType, () => [[], []]);
}

export class NetworkQuery extends Record {
    constructor(OrderType, OrderAt, Parameters, Status, OrderNr, Number$, CreatedBy, IsAdd, NetworkQueryType) {
        super();
        this.OrderType = OrderType;
        this.OrderAt = OrderAt;
        this.Parameters = Parameters;
        this.Status = Status;
        this.OrderNr = OrderNr;
        this.Number = Number$;
        this.CreatedBy = CreatedBy;
        this.IsAdd = IsAdd;
        this.NetworkQueryType = NetworkQueryType;
    }
}

export function NetworkQuery$reflection() {
    return record_type("Containers.Telecom.PendingOrders.NetworkQuery", [], NetworkQuery, () => [["OrderType", string_type], ["OrderAt", class_type("System.DateTime")], ["Parameters", string_type], ["Status", OrderStatus$reflection()], ["OrderNr", option_type(int32_type)], ["Number", string_type], ["CreatedBy", option_type(string_type)], ["IsAdd", option_type(bool_type)], ["NetworkQueryType", NetworkQueryType$reflection()]]);
}

export function NetworkQuery_FromOrder_6887C0F8(order) {
    return new NetworkQuery(order.Operation, order.Date, order.Parameters, OrderStatus_GetStatus_6887C0F8(order), order.OrderNr, order.Number, order.CreatedBy, order.IsAdd, new NetworkQueryType(0));
}

export function NetworkQuery_FromEvents(number, x) {
    return new NetworkQuery(x.event.type, fromDateTimeOffset(x.at, 0), JSON.stringify(x.event.argument), new OrderStatus(0), void 0, number, void 0, void 0, new NetworkQueryType(1));
}

export class ExpandAreaRowProps extends Record {
    constructor(NetworkQuery, NrOfCells, OnRetryClick, Locale) {
        super();
        this.NetworkQuery = NetworkQuery;
        this.NrOfCells = (NrOfCells | 0);
        this.OnRetryClick = OnRetryClick;
        this.Locale = Locale;
    }
}

export function ExpandAreaRowProps$reflection() {
    return record_type("Containers.Telecom.PendingOrders.ExpandAreaRowProps", [], ExpandAreaRowProps, () => [["NetworkQuery", NetworkQuery$reflection()], ["NrOfCells", int32_type], ["OnRetryClick", lambda_type(class_type("System.DateTime"), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))], ["Locale", Locale$reflection()]]);
}

const renderExpandAreaRow = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_1, inputRecord, copyOfStruct, copyOfStruct_1, arg_1, arg_3, arg_4, children_56, props_55, children_54, children_26, children_24, children_10, children_6, arg_6, arg_5, children_16, children_12, children_14, children_22, children_18, children_20, children_48, children_46, children_32, children_30, children_38, children_34, children_44, props_53, children_52;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const retryModalIsOpenState = react.useState(false);
    const retryDateState = react.useState(now_1());
    const retrySaveState = react.useState(new SaveStatus(0));
    let addType;
    const matchValue = props.NetworkQuery.IsAdd;
    if (matchValue != null) {
        const isAdd = matchValue;
        addType = (isAdd ? getTranslation("CustomerContract.Invoicee.Subscriptions.Order.Addition") : getTranslation("CustomerContract.Invoicee.Subscriptions.Order.Removal"));
    }
    else {
        addType = "-";
    }
    let retryModalHtml;
    const matchValue_1 = retryModalIsOpenState[0];
    if (matchValue_1) {
        let contentsHtml;
        const children_3 = [renderLabelContents(getTranslation("Common.Number"), props.NetworkQuery.Number), renderLabelContents(getTranslation("CustomerContract.Invoicee.Subscriptions.Order.OrderType"), props.NetworkQuery.OrderType), renderLabelContents(getTranslation("CustomerContract.Invoicee.Subscriptions.Order.Parameters"), props.NetworkQuery.Parameters), (children_1 = [inputDate((inputRecord = DateOptions_get_getDefault(), new DateOptions(ofArray([Id_1("retry-modal-input-date"), FormatDateBy((date) => DateTimeExtensions_toDateHHmmss(props.Locale.ILocale, date)), Locale_1(props.Locale.FlatpickrLocale), EnableTimePicker(true), Value(retryDateState[0]), OnChange((arg) => {
            retryDateState[1](arg);
        }), EnableRanges(singleton_1([(copyOfStruct = now_1(), addDays(copyOfStruct, -1)), (copyOfStruct_1 = now_1(), addYears(copyOfStruct_1, 100))]))]), getTranslation("CustomerContract.Invoicee.Subscriptions.Order.OrderTime"), true, inputRecord.Disabled, inputRecord.OnClearClick)))], react.createElement("div", {
            className: "mt-4",
        }, ...children_1))];
        contentsHtml = react.createElement(react.Fragment, {}, ...children_3);
        let bodyHtml;
        const props_5 = [new HTMLAttr(65, stackClasses(ofArray(["pb-3", "pl-3", "pr-3"])))];
        bodyHtml = react.createElement("div", keyValueList(props_5, 1), contentsHtml);
        const matchValue_2 = retrySaveState[0];
        retryModalHtml = ((matchValue_2.tag === 0) ? renderModal((arg_1 = getTranslation("Common.CreateNew"), toText(printf("%s order"))(arg_1)), bodyHtml, getTranslation("Common.Cancel"), getTranslation("Common.Save"), (_arg) => {
            retryModalIsOpenState[1](false);
        }, (_arg_1) => {
            retrySaveState[1](new SaveStatus(1));
            startImmediate(singleton.Delay(() => singleton.Bind(props.OnRetryClick(retryDateState[0]), (_arg_2) => {
                const result = _arg_2;
                return singleton.Combine((result.tag === 1) ? ((retrySaveState[1](new SaveStatus(3, result.fields[0])), singleton.Zero())) : ((retrySaveState[1](new SaveStatus(2)), singleton.Zero())), singleton.Delay(() => singleton.Return()));
            })));
        }) : render_1(true, new ModalSize(1), (arg_3 = getTranslation("Common.CreateNew"), toText(printf("%s order"))(arg_3)), singleton_1([(arg_4 = getTranslation("Common.Saving"), toText(printf("%s order"))(arg_4)), matchValue_2]), getTranslation("Common.Close"), (_arg_3) => {
            retryDateState[1](now_1());
            retryModalIsOpenState[1](false);
            retrySaveState[1](new SaveStatus(0));
        }));
    }
    else {
        retryModalHtml = react.createElement(react.Fragment, {});
    }
    const children_58 = [(children_56 = [(props_55 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "justify-content-between"])))], (children_54 = [(children_26 = [(children_24 = [(children_10 = [(children_6 = [(arg_6 = getTranslation("CustomerContract.Invoicee.Subscriptions.Order.Removal"), (arg_5 = getTranslation("CustomerContract.Invoicee.Subscriptions.Order.Addition"), toText(printf("%s/%s: "))(arg_5)(arg_6)))], react.createElement("td", {}, ...children_6)), react.createElement("td", {}, addType)], react.createElement("tr", {}, ...children_10)), (children_16 = [(children_12 = [getTranslation("Common.Status") + ": "], react.createElement("td", {}, ...children_12)), (children_14 = [OrderStatus_GetTitle_11D407F6(getTranslation)(props.NetworkQuery.Status)], react.createElement("td", {}, ...children_14))], react.createElement("tr", {}, ...children_16)), (children_22 = [(children_18 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Order.CreatedBy") + ": "], react.createElement("td", {}, ...children_18)), (children_20 = [defaultArg(props.NetworkQuery.CreatedBy, "-")], react.createElement("td", {}, ...children_20))], react.createElement("tr", {}, ...children_22))], react.createElement("tbody", {}, ...children_24))], react.createElement("table", {
        className: "expandable-area__table",
    }, ...children_26)), (children_48 = [(children_46 = [(children_32 = [react.createElement("td", {}, "OrderNr: "), (children_30 = [optToStr(props.NetworkQuery.OrderNr)], react.createElement("td", {}, ...children_30))], react.createElement("tr", {}, ...children_32)), (children_38 = [(children_34 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Order.Parameters") + ": "], react.createElement("td", {}, ...children_34)), react.createElement("td", {}, props.NetworkQuery.Parameters)], react.createElement("tr", {}, ...children_38)), (children_44 = [react.createElement("td", {}, " "), react.createElement("td", {}, " ")], react.createElement("tr", {}, ...children_44))], react.createElement("tbody", {}, ...children_46))], react.createElement("table", {
        className: "expandable-area__table",
    }, ...children_48)), (props_53 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-end"])))], (children_52 = toList(delay(() => {
        let inputRecord_1;
        if (props.NetworkQuery.NetworkQueryType.tag === 0) {
            const matchValue_4 = props.NetworkQuery.Status;
            switch (matchValue_4.tag) {
                case 2: {
                    return singleton_2(react.createElement(react.Fragment, {}));
                }
                case 1:
                case 3: {
                    return singleton_2(wrappedButton(new ButtonKind(0), (inputRecord_1 = ButtonProps_get_getDefault(), new ButtonProps(getTranslation("CustomerContract.Invoicee.Subscriptions.Order.Retry"), inputRecord_1.Content, (_arg_5) => {
                        retryModalIsOpenState[1](true);
                    }, inputRecord_1.Disabled, "order-retry-btn", inputRecord_1.SaveStatus, inputRecord_1.HTMLProps, inputRecord_1.ExtraClasses, inputRecord_1.Icon))));
                }
                default: {
                    return singleton_2(react.createElement(react.Fragment, {}));
                }
            }
        }
        else {
            return singleton_2(react.createElement(react.Fragment, {}));
        }
    })), react.createElement("div", keyValueList(props_53, 1), ...children_52)))], react.createElement("div", keyValueList(props_55, 1), ...children_54))), retryModalHtml], react.createElement("td", {
        colSpan: props.NrOfCells,
        className: "order-table__expandable-area",
    }, ...children_56))];
    return react.createElement("tr", {}, ...children_58);
}, "ExpandAreaRow", uncurry(2, void 0), void 0, "renderExpandAreaRow", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Telecom\\PendingOrders.fs", 318);

const oneWeekHours = int32ToString(~(~(() => {
    let copyOfStruct = create(7, 0, 0, 0);
    return totalHours(copyOfStruct);
})()));

const oneMonthHours = (() => {
    let copyOfStruct;
    const now = now_1();
    return int32ToString(~(~((copyOfStruct = create(daysInMonth(year(now), month(now)), 0, 0, 0), totalHours(copyOfStruct)))));
})();

const oneYearHours = int32ToString(~(~(() => {
    let copyOfStruct = create(365, 0, 0, 0);
    return totalHours(copyOfStruct);
})()));

const oneHundredYears = int32ToString(~(~(() => {
    let copyOfStruct = create(36500, 0, 0, 0);
    return totalHours(copyOfStruct);
})()));

export class EditOrderModalState extends Record {
    constructor(Order, NewDate, CancelOrderSaveStatus, CreateNewOrderSaveStatus) {
        super();
        this.Order = Order;
        this.NewDate = NewDate;
        this.CancelOrderSaveStatus = CancelOrderSaveStatus;
        this.CreateNewOrderSaveStatus = CreateNewOrderSaveStatus;
    }
}

export function EditOrderModalState$reflection() {
    return record_type("Containers.Telecom.PendingOrders.EditOrderModalState", [], EditOrderModalState, () => [["Order", option_type(NetworkQuery$reflection())], ["NewDate", class_type("System.DateTime")], ["CancelOrderSaveStatus", SaveStatus$reflection()], ["CreateNewOrderSaveStatus", SaveStatus$reflection()]]);
}

export class RenderHeadingAndTableProps extends Record {
    constructor(OrderDTOs, Locale, CancelOrderFn, ResetCancelOrderStatusFn, ClientNr, NetworkContractNr, ContractNr, Number$, CancelOrderStatus, LoadOrders, LoadOperationStatuses, LoadPendingProvisioningEvents, PendingProvisioningEvents, ResetPendingProvisioningEvents, ArchiveOrder, CancelExistingOrder, SaveNewOrder, UpdatePendingChangeDate) {
        super();
        this.OrderDTOs = OrderDTOs;
        this.Locale = Locale;
        this.CancelOrderFn = CancelOrderFn;
        this.ResetCancelOrderStatusFn = ResetCancelOrderStatusFn;
        this.ClientNr = (ClientNr | 0);
        this.NetworkContractNr = NetworkContractNr;
        this.ContractNr = (ContractNr | 0);
        this.Number = Number$;
        this.CancelOrderStatus = CancelOrderStatus;
        this.LoadOrders = LoadOrders;
        this.LoadOperationStatuses = LoadOperationStatuses;
        this.LoadPendingProvisioningEvents = LoadPendingProvisioningEvents;
        this.PendingProvisioningEvents = PendingProvisioningEvents;
        this.ResetPendingProvisioningEvents = ResetPendingProvisioningEvents;
        this.ArchiveOrder = ArchiveOrder;
        this.CancelExistingOrder = CancelExistingOrder;
        this.SaveNewOrder = SaveNewOrder;
        this.UpdatePendingChangeDate = UpdatePendingChangeDate;
    }
}

export function RenderHeadingAndTableProps$reflection() {
    return record_type("Containers.Telecom.PendingOrders.RenderHeadingAndTableProps", [], RenderHeadingAndTableProps, () => [["OrderDTOs", list_type(OrderDTO$reflection())], ["Locale", Locale$reflection()], ["CancelOrderFn", lambda_type(int32_type, unit_type)], ["ResetCancelOrderStatusFn", lambda_type(unit_type, unit_type)], ["ClientNr", int32_type], ["NetworkContractNr", option_type(int32_type)], ["ContractNr", int32_type], ["Number", option_type(string_type)], ["CancelOrderStatus", SaveStatus$reflection()], ["LoadOrders", lambda_type(unit_type, unit_type)], ["LoadOperationStatuses", lambda_type(unit_type, unit_type)], ["LoadPendingProvisioningEvents", lambda_type(unit_type, unit_type)], ["PendingProvisioningEvents", LoadState$2$reflection(list_type(PendingProvisioningEventsDTO$reflection()), string_type)], ["ResetPendingProvisioningEvents", lambda_type(unit_type, unit_type)], ["ArchiveOrder", lambda_type(int32_type, lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))))], ["CancelExistingOrder", lambda_type(int32_type, lambda_type(int32_type, lambda_type(int32_type, class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))))], ["SaveNewOrder", lambda_type(int32_type, lambda_type(int32_type, lambda_type(string_type, lambda_type(CreateOrderDTO$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])])))))], ["UpdatePendingChangeDate", lambda_type(int32_type, lambda_type(int32_type, lambda_type(UTC$reflection(), class_type("Microsoft.FSharp.Control.FSharpAsync`1", [union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, string_type], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", string_type]]])]))))]]);
}

const renderHeadingAndTable = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_4, _arg_2, _arg_3, _arg_4, children_11, children_7, props_10, children_9, inputRecord, arg_2, arg_1, arg_13, latestStatusOpt_1, orders, props_53, children_52, children_48, children_50, inputRecord_1, OptionValues, last;
    const translationsLoadState = useSelector((state) => state.Model.Translations);
    const getTranslation = (key) => getTranslationFrom(translationsLoadState, key);
    const reduxDispatch = useDispatch();
    let hoursBackwardState;
    const arg = defaultArg(getItem("PendingOrders", "TimeFilter"), "72");
    hoursBackwardState = react.useState(arg);
    const infoModalOrderState = react.useState(void 0);
    const cancelPendingOrderNrState = react.useState(void 0);
    const expandAreaRowIdState = react.useState(void 0);
    const editOrderModalState = react.useState(new EditOrderModalState(void 0, now_1(), new SaveStatus(0), new SaveStatus(0)));
    let cancelPendingOrderModalHtml;
    const matchValue = cancelPendingOrderNrState[0];
    if (matchValue != null) {
        const orderNr = matchValue | 0;
        let bodyHtml;
        const children_1 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.AreYouSureCancelOrder")];
        bodyHtml = react.createElement("div", {}, ...children_1);
        cancelPendingOrderModalHtml = renderModal(getTranslation("Common.Confirm"), bodyHtml, getTranslation("Common.No"), getTranslation("Common.Yes"), (_arg) => {
            cancelPendingOrderNrState[1](void 0);
        }, (_arg_1) => {
            props.CancelOrderFn(orderNr);
            cancelPendingOrderNrState[1](void 0);
        });
    }
    else {
        cancelPendingOrderModalHtml = react.createElement(react.Fragment, {});
    }
    react.useEffect(() => {
        props.LoadPendingProvisioningEvents();
    }, [props.ClientNr, props.ContractNr, props.Number]);
    let infoModalHtml;
    const matchValue_1 = infoModalOrderState[0];
    if (matchValue_1 != null) {
        const dto = matchValue_1;
        infoModalHtml = renderAsModal("Error", (children_4 = [renderLabelContents(getTranslation("CustomerContract.Invoicee.Subscriptions.Order.OrderType"), dto.OrderType), renderLabelContents(getTranslation("CustomerContract.Invoicee.Subscriptions.Order.OrderTime"), DateTimeExtensions_toDateHHmmss(props.Locale.ILocale, dto.OrderAt)), renderLabelContents(getTranslation("CustomerContract.Invoicee.Subscriptions.Order.Parameters"), dto.Parameters), renderLabelContents(getTranslation("CustomerContract.Invoicee.Subscriptions.Order.Errors"), defaultArg((_arg_2 = dto.Status, (_arg_2.tag === 1) ? _arg_2.fields[1] : (void 0)), "")), renderLabelContents(getTranslation("CustomerContract.Invoicee.Subscriptions.Order.ErrorDate"), defaultArg(map((date) => DateTimeExtensions_toDateHHmmss(props.Locale.ILocale, date), (_arg_3 = dto.Status, (_arg_3.tag === 1) ? _arg_3.fields[0] : (void 0))), "")), renderLabelContents(getTranslation("CustomerContract.Invoicee.Subscriptions.Order.SuccessTime"), defaultArg(map((date_1) => DateTimeExtensions_toDateHHmmss(props.Locale.ILocale, date_1), (_arg_4 = dto.Status, (_arg_4.tag === 2) ? _arg_4.fields[0] : (void 0))), ""))], react.createElement("div", {}, ...children_4)), new MessageType(0), getTranslation("Common.Ok"), (_arg_5) => {
            infoModalOrderState[1](void 0);
        });
    }
    else {
        infoModalHtml = react.createElement(react.Fragment, {});
    }
    const headers = ofArray([getTranslation("Common.Number"), getTranslation("CustomerContract.Invoicee.Subscriptions.Order.OrderType"), getTranslation("CustomerContract.Invoicee.Subscriptions.Order.OrderTime"), getTranslation("CustomerContract.Invoicee.Subscriptions.Order.Parameters"), getTranslation("Common.Status"), getTranslation("CustomerContract.Invoicee.Subscriptions.Order.Errors"), ""]);
    let editOrderDateModalHtml;
    const matchValue_2 = (editOrderModalState[0]).Order;
    if (matchValue_2 != null) {
        const order = matchValue_2;
        const matchValue_3 = [(editOrderModalState[0]).CancelOrderSaveStatus, (editOrderModalState[0]).CreateNewOrderSaveStatus];
        let pattern_matching_result, cancelStatus, createStatus;
        if (matchValue_3[0].tag === 0) {
            if (matchValue_3[1].tag === 0) {
                pattern_matching_result = 0;
            }
            else {
                pattern_matching_result = 1;
                cancelStatus = matchValue_3[0];
                createStatus = matchValue_3[1];
            }
        }
        else {
            pattern_matching_result = 1;
            cancelStatus = matchValue_3[0];
            createStatus = matchValue_3[1];
        }
        switch (pattern_matching_result) {
            case 0: {
                let bodyHtml_2;
                const children_13 = [renderLabelContents("#", optToStr(order.OrderNr)), renderLabelContents(getTranslation("Common.Number"), order.Number), renderLabelContents(getTranslation("CustomerContract.Invoicee.Subscriptions.Order.OrderType"), order.OrderType), renderLabelContents(getTranslation("CustomerContract.Invoicee.Subscriptions.Order.Parameters"), order.Parameters), (children_11 = [(children_7 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Order.OrderTime") + ": "], react.createElement("span", {
                    className: "font-weight-bold",
                    ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Order.OrderTime",
                }, ...children_7)), (props_10 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "fit-content"])))], (children_9 = [inputDate((inputRecord = DateOptions_get_getDefault(), new DateOptions(ofArray([FormatDateBy((date_2) => DateTimeExtensions_toDateHHmm(props.Locale.ILocale, date_2)), Locale_1(props.Locale.FlatpickrLocale), OnChange((value_5) => {
                    editOrderModalState[1]((x) => (new EditOrderModalState(x.Order, value_5, x.CancelOrderSaveStatus, x.CreateNewOrderSaveStatus)));
                }), Value((editOrderModalState[0]).NewDate), EnableBy((d_3) => {
                    let copyOfStruct;
                    return compare(d_3, (copyOfStruct = now_1(), addDays(copyOfStruct, -1))) >= 0;
                }), TimeTwentyFour(true), EnableTimePicker(true)]), inputRecord.LabelText, true, inputRecord.Disabled, inputRecord.OnClearClick)))], react.createElement("div", keyValueList(props_10, 1), ...children_9)))], react.createElement("div", {}, ...children_11))];
                bodyHtml_2 = react.createElement("div", {}, ...children_13);
                const matchValue_4 = (editOrderModalState[0]).Order;
                if (matchValue_4 != null) {
                    const order_1 = matchValue_4;
                    editOrderDateModalHtml = render_2((editOrderModalState[0]).Order != null, new ModalSize(1), (arg_2 = getTranslation("CustomerContract.Invoicee.Subscriptions.Order"), (arg_1 = getTranslation("Common.Change"), toText(printf("%s %s"))(arg_1)(arg_2))), bodyHtml_2, getTranslation("Common.Cancel"), getTranslation("Common.Change"), (_arg_7) => {
                        editOrderModalState[1]((x_1) => (new EditOrderModalState(void 0, x_1.NewDate, x_1.CancelOrderSaveStatus, x_1.CreateNewOrderSaveStatus)));
                    }, (_arg_8) => {
                        const matchValue_5 = [props.NetworkContractNr, order_1.OrderNr];
                        let pattern_matching_result_1, networkContractNr, orderNr_1;
                        if (matchValue_5[0] != null) {
                            if (matchValue_5[1] != null) {
                                pattern_matching_result_1 = 0;
                                networkContractNr = matchValue_5[0];
                                orderNr_1 = matchValue_5[1];
                            }
                            else {
                                pattern_matching_result_1 = 1;
                            }
                        }
                        else {
                            pattern_matching_result_1 = 1;
                        }
                        switch (pattern_matching_result_1) {
                            case 0: {
                                startImmediate(singleton.Delay(() => {
                                    editOrderModalState[1]((x_2) => (new EditOrderModalState(x_2.Order, x_2.NewDate, new SaveStatus(1), x_2.CreateNewOrderSaveStatus)));
                                    return singleton.Bind((orderNr_1 < 0) ? singleton.Return(new FSharpResult$2(0, void 0)) : props.CancelExistingOrder(props.ClientNr, networkContractNr, orderNr_1), (_arg_9) => {
                                        let utcDate;
                                        const cancelResult = _arg_9;
                                        if (cancelResult.tag === 0) {
                                            editOrderModalState[1]((x_6) => (new EditOrderModalState(x_6.Order, x_6.NewDate, new SaveStatus(2), new SaveStatus(1))));
                                            return singleton.Bind((orderNr_1 < 0) ? ((utcDate = defaultArgWith(UTC_ofDateTime_7F9DDECF(toUniversalTime((editOrderModalState[0]).NewDate)), () => toFail(printf("[UpdatePendingChangeDate] Can\u0027t parse UTC date."))), props.UpdatePendingChangeDate(props.ClientNr, Math.abs(orderNr_1), utcDate))) : props.SaveNewOrder(props.ClientNr, networkContractNr, order_1.OrderType, new CreateOrderDTO(props.ContractNr, true, order_1.Number, DateTimeExtensions_yyyy_MM_ddTHH_mm_ssZ((editOrderModalState[0]).NewDate), ofArray(split(order_1.Parameters, [","], null, 0)))), (_arg_10) => {
                                                const saveResult = _arg_10;
                                                if (saveResult.tag === 1) {
                                                    editOrderModalState[1]((x_8) => (new EditOrderModalState(x_8.Order, x_8.NewDate, x_8.CancelOrderSaveStatus, new SaveStatus(3, saveResult.fields[0]))));
                                                    return singleton.Zero();
                                                }
                                                else {
                                                    editOrderModalState[1]((x_7) => (new EditOrderModalState(x_7.Order, x_7.NewDate, x_7.CancelOrderSaveStatus, new SaveStatus(2))));
                                                    return singleton.Zero();
                                                }
                                            });
                                        }
                                        else {
                                            editOrderModalState[1]((x_5) => (new EditOrderModalState(x_5.Order, x_5.NewDate, new SaveStatus(3, cancelResult.fields[0]), x_5.CreateNewOrderSaveStatus)));
                                            return singleton.Zero();
                                        }
                                    });
                                }));
                                break;
                            }
                            case 1: {
                                logei("[editOrderDateModalOpenState] Missing NetworkContractNr or OrderNr");
                                break;
                            }
                        }
                    });
                }
                else {
                    editOrderDateModalHtml = react.createElement(react.Fragment, {});
                }
                break;
            }
            case 1: {
                const saveItems = ofArray([[getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.CancelCurrentOrder"), cancelStatus], [getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.SaveNewOrder"), createStatus]]);
                editOrderDateModalHtml = render_1(true, new ModalSize(1), getTranslation("Common.Saving"), saveItems, getTranslation("Common.Ok"), (_arg_11) => {
                    editOrderModalState[1](new EditOrderModalState(void 0, now_1(), new SaveStatus(0), new SaveStatus(0)));
                    props.LoadOrders();
                });
                break;
            }
        }
    }
    else {
        editOrderDateModalHtml = react.createElement(react.Fragment, {});
    }
    let rows;
    let numberSpecificEvents;
    const matchValue_11 = props.PendingProvisioningEvents;
    if (matchValue_11.tag === 2) {
        const list_2 = collect((x_19) => x_19.events, filter((x_18) => equals(x_18.number, props.Number), matchValue_11.fields[0]));
        numberSpecificEvents = map_1((arg_13 = optToStr(props.Number), (arg_14) => NetworkQuery_FromEvents(arg_13, arg_14)), list_2);
    }
    else {
        numberSpecificEvents = empty();
    }
    rows = map_1((order_2) => {
        let props_17, children_16, children_24, props_23, children_22, icon, timeStr, titleStr, children_31, children_27, matchValue_7, orderNr_7, props_35, children_34, props_40;
        const status = order_2.Status;
        const operationCellHtml = Elements_renderCell(order_2.OrderType);
        const numberCellHtml = Elements_renderCell(order_2.Number);
        let dateCellHtml;
        const dateHtml = DateTimeExtensions_toDateHHmmss(props.Locale.ILocale, order_2.OrderAt);
        let editButtonHtml;
        const matchValue_6 = [status, compare(order_2.OrderAt, now_1()) > 0, props.NetworkContractNr, order_2.OrderNr];
        let pattern_matching_result_2;
        if (matchValue_6[0].tag === 0) {
            if (matchValue_6[1]) {
                if (matchValue_6[2] != null) {
                    if (matchValue_6[3] != null) {
                        pattern_matching_result_2 = 0;
                    }
                    else {
                        pattern_matching_result_2 = 1;
                    }
                }
                else {
                    pattern_matching_result_2 = 1;
                }
            }
            else {
                pattern_matching_result_2 = 1;
            }
        }
        else {
            pattern_matching_result_2 = 1;
        }
        switch (pattern_matching_result_2) {
            case 0: {
                const children_18 = [(props_17 = [new DOMAttr(40, (_arg_12) => {
                    editOrderModalState[1]((x_9) => (new EditOrderModalState(order_2, order_2.OrderAt, x_9.CancelOrderSaveStatus, x_9.CreateNewOrderSaveStatus)));
                }), new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center", "ml-2", "pointer"])))], (children_16 = [getMaterialIcon("edit")], react.createElement("span", keyValueList(props_17, 1), ...children_16)))];
                editButtonHtml = react.createElement(react.Fragment, {}, ...children_18);
                break;
            }
            case 1: {
                editButtonHtml = react.createElement(react.Fragment, {});
                break;
            }
        }
        dateCellHtml = Elements_renderCell(react.createElement("div", {
            className: "d-flex",
        }, dateHtml, editButtonHtml));
        const paramsCellHtml = Elements_renderCell(renderTruncatedString(order_2.Parameters, 20));
        const errorCellHtml = Elements_renderCell((status.tag === 1) ? ((children_24 = [(props_23 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "pointer"]))), new DOMAttr(40, (_arg_13) => {
            infoModalOrderState[1](order_2);
        })], (children_22 = [getMaterialIcon("info")], react.createElement("span", keyValueList(props_23, 1), ...children_22))), truncateWithEllipsis(20, status.fields[1])], react.createElement("div", {
            className: "d-flex",
        }, ...children_24))) : react.createElement(react.Fragment, {}));
        const statusCellHtml = Elements_renderCell((status.tag === 3) ? ((icon = OrderStatus_get_GetMaterialIcon()(status), (timeStr = DateTimeExtensions_toDateHHmmss(props.Locale.ILocale, status.fields[0]), (titleStr = OrderStatus_GetTitle_11D407F6(getTranslation)(status), (children_31 = [(children_27 = [getMaterialIcon(icon)], react.createElement("span", {
            className: "d-flex",
            title: titleStr,
        }, ...children_27)), react.createElement("span", {}, timeStr)], react.createElement("div", {
            className: "row__status",
        }, ...children_31)))))) : ((status.tag === 1) ? ((icon = OrderStatus_get_GetMaterialIcon()(status), (timeStr = DateTimeExtensions_toDateHHmmss(props.Locale.ILocale, status.fields[0]), (titleStr = OrderStatus_GetTitle_11D407F6(getTranslation)(status), (children_31 = [(children_27 = [getMaterialIcon(icon)], react.createElement("span", {
            className: "d-flex",
            title: titleStr,
        }, ...children_27)), react.createElement("span", {}, timeStr)], react.createElement("div", {
            className: "row__status",
        }, ...children_31)))))) : ((status.tag === 0) ? react.createElement(react.Fragment, {}) : ((icon = OrderStatus_get_GetMaterialIcon()(status), (timeStr = DateTimeExtensions_toDateHHmmss(props.Locale.ILocale, status.fields[0]), (titleStr = OrderStatus_GetTitle_11D407F6(getTranslation)(status), (children_31 = [(children_27 = [getMaterialIcon(icon)], react.createElement("span", {
            className: "d-flex",
            title: titleStr,
        }, ...children_27)), react.createElement("span", {}, timeStr)], react.createElement("div", {
            className: "row__status",
        }, ...children_31)))))))));
        const cancelOrArchivePendingRequestCellHtml = Elements_renderCell((matchValue_7 = [status, order_2.OrderNr], (matchValue_7[0].tag === 0) ? ((matchValue_7[1] != null) ? ((orderNr_7 = (matchValue_7[1] | 0), (props_35 = [new HTMLAttr(65, "row__cancel-btn"), new HTMLAttr(158, getTranslation("Common.Cancel")), new DOMAttr(40, (e_2) => {
            e_2.stopPropagation();
            cancelPendingOrderNrState[1](orderNr_7);
        })], (children_34 = [getMaterialIcon("cancel")], react.createElement("div", keyValueList(props_35, 1), ...children_34))))) : react.createElement("span", {})) : ((matchValue_7[1] != null) ? renderArchiveButton(new ArchiveButtonProps(props.ClientNr, props.NetworkContractNr, matchValue_7[1], props.ArchiveOrder, props.LoadOrders)) : react.createElement("span", {}))));
        const rowClasses = stackClasses(ofArray(["order-table__row", (status.tag === 1) ? "order-table__row--error" : ((status.tag === 2) ? "order-table__row--success" : ((status.tag === 3) ? "order-table__row--cancelled" : "order-table__row--pending"))]));
        const cells = ofArray([numberCellHtml, operationCellHtml, dateCellHtml, paramsCellHtml, statusCellHtml, errorCellHtml, cancelOrArchivePendingRequestCellHtml]);
        let expandAreaHtml;
        const matchValue_8 = equals(expandAreaRowIdState[0], order_2);
        expandAreaHtml = (matchValue_8 ? renderExpandAreaRow(new ExpandAreaRowProps(order_2, length(cells), (localDate) => {
            let networkContractNr_2, isAdd;
            const matchValue_9 = [order_2.IsAdd, props.NetworkContractNr, order_2.OrderNr];
            let pattern_matching_result_3, isAdd_1, networkContractNr_3, orderNr_11, orderNr_12;
            if (matchValue_9[0] != null) {
                if (matchValue_9[1] != null) {
                    if (matchValue_9[2] != null) {
                        if ((networkContractNr_2 = (matchValue_9[1] | 0), (isAdd = matchValue_9[0], matchValue_9[2] > 0))) {
                            pattern_matching_result_3 = 2;
                            isAdd_1 = matchValue_9[0];
                            networkContractNr_3 = matchValue_9[1];
                            orderNr_11 = matchValue_9[2];
                        }
                        else if (matchValue_9[2] < 0) {
                            pattern_matching_result_3 = 3;
                            orderNr_12 = matchValue_9[2];
                        }
                        else {
                            pattern_matching_result_3 = 4;
                        }
                    }
                    else {
                        pattern_matching_result_3 = 4;
                    }
                }
                else {
                    pattern_matching_result_3 = 1;
                }
            }
            else {
                pattern_matching_result_3 = 0;
            }
            switch (pattern_matching_result_3) {
                case 0: {
                    const x_10 = new FSharpResult$2(1, toText(printf("Cannot create Order. Copy and paste this message to Customer Support: %A"))(order_2));
                    return singleton.Return(x_10);
                }
                case 1: {
                    return singleton.Return(new FSharpResult$2(1, "Cannot create Order. Missing NetworkContractNr."));
                }
                case 2: {
                    return createOrder(props.ClientNr, networkContractNr_3, order_2.OrderType, new CreateOrderDTO(props.ContractNr, isAdd_1, order_2.Number, DateTimeExtensions_toIso8601(localDate), ofArray(split(order_2.Parameters, [","], null, 0))));
                }
                case 3: {
                    const matchValue_10 = UTC_ofDateTime_7F9DDECF(toUniversalTime(localDate));
                    if (matchValue_10 == null) {
                        return singleton.Return(new FSharpResult$2(1, "Cannot update PendingChange, unable to parse UTC date."));
                    }
                    else {
                        const utc = matchValue_10;
                        return updatePendingChangeDate(props.ClientNr, Math.abs(orderNr_12), utc);
                    }
                }
                case 4: {
                    const x_16 = new FSharpResult$2(1, toText(printf("Cannot create Order. Order: %A"))(order_2));
                    return singleton.Return(x_16);
                }
            }
        }, props.Locale)) : react.createElement(react.Fragment, {}));
        const children_41 = [(props_40 = toList(delay(() => append(singleton_2(new HTMLAttr(65, rowClasses)), delay(() => append(singleton_2(new DOMAttr(40, (_arg_14) => {
            if (equals(expandAreaRowIdState[0], order_2)) {
                expandAreaRowIdState[1](void 0);
            }
            else {
                expandAreaRowIdState[1](order_2);
            }
        })), delay(() => {
            let copyOfStruct_1;
            return (order_2.OrderNr != null) ? singleton_2(new Prop(0, (copyOfStruct_1 = value_8(order_2.OrderNr), int32ToString(copyOfStruct_1)))) : empty_1();
        })))))), react.createElement("tr", keyValueList(props_40, 1), ...cells)), expandAreaHtml];
        return react.createElement(react.Fragment, {}, ...children_41);
    }, sortByDescending((order_5) => order_5.OrderAt, filter((order_4) => {
        let copyOfStruct_2;
        return compare(order_4.OrderAt, (copyOfStruct_2 = now_1(), addHours(copyOfStruct_2, -1 * parse(hoursBackwardState[0])))) > 0;
    }, (latestStatusOpt_1 = fold((latestStatusOpt, elem) => {
        if (elem.Operation === "Status") {
            if (latestStatusOpt == null) {
                return elem;
            }
            else if (compare(elem.Date, latestStatusOpt.Date) > 0) {
                return elem;
            }
            else {
                return latestStatusOpt;
            }
        }
        else {
            return latestStatusOpt;
        }
    }, void 0, props.OrderDTOs), append_1(numberSpecificEvents, map_1(NetworkQuery_FromOrder_6887C0F8, (orders = filter((order_3) => (order_3.Operation !== "Status"), props.OrderDTOs), (latestStatusOpt_1 == null) ? orders : cons(latestStatusOpt_1, orders)))))), {
        Compare: compare,
    }));
    let cancelOrderErrorModal;
    const matchValue_12 = props.CancelOrderStatus;
    cancelOrderErrorModal = ((matchValue_12.tag === 3) ? renderAsModal("Error", react.createElement("div", {}, matchValue_12.fields[0]), new MessageType(2), getTranslation("Common.Close"), (_arg_15) => {
        props.ResetCancelOrderStatusFn();
    }) : react.createElement(react.Fragment, {}));
    let tableHtml;
    const headersHtml = map_1(renderHeader, headers);
    tableHtml = Pagination()(new PageinationProps$1((rowsTr) => renderCustomTable(headersHtml, rowsTr), rows, 5, 0));
    let errorModalHtml;
    const matchValue_13 = props.PendingProvisioningEvents;
    errorModalHtml = ((matchValue_13.tag === 3) ? renderAsModal("Error", matchValue_13.fields[0], new MessageType(2), getTranslation("Common.Close"), (_arg_16) => {
        props.ResetPendingProvisioningEvents();
    }) : react.createElement(react.Fragment, {}));
    let tableAndModalsHtml;
    const children_46 = isEmpty(rows) ? singleton_1(info(getTranslation("CustomerContract.Invoicee.Subscriptions.Order.NoRequests").split(""))) : ofArray([tableHtml, infoModalHtml, cancelOrderErrorModal, cancelPendingOrderModalHtml, editOrderDateModalHtml]);
    tableAndModalsHtml = react.createElement("div", {
        className: "mt-2",
    }, ...children_46);
    const children_54 = [(props_53 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center", "mb-3"])))], (children_52 = [(children_48 = [getTranslation("CustomerContract.Invoicee.Subscriptions.Order.Requests")], react.createElement("h5", {
        className: "mb-0",
        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Order.Requests",
    }, ...children_48)), (children_50 = [selectOption((inputRecord_1 = SelectOption_get_getDefault(), (OptionValues = ((last = getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.Last"), ofArray([["1", last + " 1h"], ["8", last + " 8h"], ["24", last + " 24h"], ["48", last + " 48h"], ["72", last + " 72h"], [oneWeekHours, (last + " ") + getTranslation("Common.Week").toLocaleLowerCase()], [oneMonthHours, (last + " ") + getTranslation("Common.Month").toLocaleLowerCase()], [oneYearHours, (last + " ") + getTranslation("Common.Year").toLocaleLowerCase()], [oneHundredYears, getTranslation("CustomerContract.Invoicee.Subscriptions.Telecom.ShowEverything")]]))), new SelectOption(new ValueProp(0, hoursBackwardState[0], (e_3) => {
        const strValue = Browser_Types_Event__Event_get_Value(e_3);
        setItem("PendingOrders", "TimeFilter", strValue);
        hoursBackwardState[1](strValue);
    }), "orders-select-hours-backward", OptionValues, inputRecord_1.Classes, inputRecord_1.LabelText, inputRecord_1.Disabled, inputRecord_1.HTMLProps))))], react.createElement("div", {
        className: "pending-requests__filter",
    }, ...children_50))], react.createElement("div", keyValueList(props_53, 1), ...children_52))), renderLoadingBar(new LoadingBarProps(() => {
        props.LoadOrders();
        const matchValue_14 = props.NetworkContractNr;
        if (matchValue_14 != null) {
            reduxDispatch(loadOperationStatusesThunk(props.ClientNr, matchValue_14, props.Number));
        }
        else {
            logwi("Cannot loadOperationStatuses, missing networkContractNr.");
        }
    }, 7000)), tableAndModalsHtml, errorModalHtml];
    return react.createElement("div", {}, ...children_54);
}, "HeadingAndTable", Helpers_equalsButFunctions, void 0, "renderHeadingAndTable", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Telecom\\PendingOrders.fs", 949);

export class PlacedOrdersSectionProps extends Record {
    constructor(GetTranslation, Locale, GlobalDependencies, ContractNr, Orders, SelectedNumberHistory, NetworkContractNr, ReloadOrdersFn, UpdateNetworkStatusFn) {
        super();
        this.GetTranslation = GetTranslation;
        this.Locale = Locale;
        this.GlobalDependencies = GlobalDependencies;
        this.ContractNr = (ContractNr | 0);
        this.Orders = Orders;
        this.SelectedNumberHistory = SelectedNumberHistory;
        this.NetworkContractNr = NetworkContractNr;
        this.ReloadOrdersFn = ReloadOrdersFn;
        this.UpdateNetworkStatusFn = UpdateNetworkStatusFn;
    }
}

export function PlacedOrdersSectionProps$reflection() {
    return record_type("Containers.Telecom.PendingOrders.PlacedOrdersSectionProps", [], PlacedOrdersSectionProps, () => [["GetTranslation", lambda_type(string_type, string_type)], ["Locale", Locale$reflection()], ["GlobalDependencies", GlobalDependencies$reflection()], ["ContractNr", int32_type], ["Orders", list_type(OrderDTO$reflection())], ["SelectedNumberHistory", option_type(NumberHistory$reflection())], ["NetworkContractNr", option_type(int32_type)], ["ReloadOrdersFn", lambda_type(unit_type, unit_type)], ["UpdateNetworkStatusFn", lambda_type(string_type, unit_type)]]);
}

export const renderPlacedOrdersSection = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_29, children_37, children_33, children_35, children_43, children_39, children_41, children_49;
    const networkDetailsModalOpenState = react.useState(false);
    const networkDetailsState = react.useState(new LoadState$2(0));
    const updateNetworkStatusState = react.useState(new SaveStatus(0));
    const cancelOrderStatusState = react.useState(new SaveStatus(0));
    const pendingProvisioningEventsState = react.useState(new LoadState$2(0));
    let networkDetailsModalHtml;
    if (!(networkDetailsModalOpenState[0])) {
        networkDetailsModalHtml = react.createElement(react.Fragment, {});
    }
    else {
        const closeModalFn = (_arg_3) => {
            networkDetailsModalOpenState[1](false);
        };
        const headerHtml = getModalHeader(props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Order.NetworkDetails"), closeModalFn);
        const footerHtml = getModalFooterContainer(modalMain(new ButtonProps(props.GetTranslation("Common.Close"), defaultProps.Content, closeModalFn, defaultProps.Disabled, "network-details-close-button", defaultProps.SaveStatus, defaultProps.HTMLProps, defaultProps.ExtraClasses, defaultProps.Icon)));
        let bodyHtml;
        const matchValue_4 = networkDetailsState[0];
        switch (matchValue_4.tag) {
            case 1: {
                bodyHtml = react.createElement("div", {
                    className: "p-4 m-4",
                }, dotsLoading);
                break;
            }
            case 3: {
                const children_27 = [error(matchValue_4.fields[0].split(""))];
                bodyHtml = react.createElement("div", {
                    className: "p-4",
                }, ...children_27);
                break;
            }
            case 2: {
                bodyHtml = getModalBodyContainer((children_29 = map_1((_arg_4) => {
                    const headers = map_1(renderHeader, ofArray(["Key", "Value", "Description"]));
                    const rows = map_1((networkDetail) => {
                        let children_9, children_13, children_15;
                        const renderCopyableCell = (text) => {
                            let children_4;
                            if (isNullOrWhiteSpace(text)) {
                                return react.createElement(react.Fragment, {});
                            }
                            else {
                                const children_6 = [react.createElement("span", {
                                    title: text,
                                    className: "cursor-help",
                                }, text), (children_4 = [getMaterialIconBySize("content_copy", new Size(0))], react.createElement("span", {
                                    className: "category-cell__copy",
                                    onClick: (_arg_5) => {
                                        map((clipboard) => clipboard.writeText(text), navigator.clipboard);
                                    },
                                }, ...children_4))];
                                return react.createElement("div", {
                                    className: "category-cell",
                                }, ...children_6);
                            }
                        };
                        let descriptionCellHtml;
                        if (isNullOrWhiteSpace(networkDetail.Description)) {
                            descriptionCellHtml = react.createElement(react.Fragment, {});
                        }
                        else {
                            const props_12 = [new HTMLAttr(65, stackClasses(ofArray(["d-flex", "align-items-center"])))];
                            const children_11 = [(children_9 = [truncateWithEllipsis(20, networkDetail.Description)], react.createElement("span", {
                                title: networkDetail.Description,
                                className: "cursor-help mr-1",
                            }, ...children_9)), MaterialIcon_render_Z384F8060("info", networkDetail.Description)];
                            descriptionCellHtml = react.createElement("div", keyValueList(props_12, 1), ...children_11);
                        }
                        const children_19 = [(children_13 = [renderCopyableCell(networkDetail.Name)], react.createElement("td", {
                            className: "cell",
                        }, ...children_13)), (children_15 = [renderCopyableCell(networkDetail.Value)], react.createElement("td", {
                            className: "cell",
                        }, ...children_15)), react.createElement("td", {
                            className: "cell",
                        }, descriptionCellHtml)];
                        return react.createElement("tr", {}, ...children_19);
                    }, _arg_4[1]);
                    const children_23 = [react.createElement("h5", {}, _arg_4[0]), renderCustomTable(headers, rows)];
                    return react.createElement("div", {
                        className: "mb-4",
                        id: "telecom-network-details-table",
                    }, ...children_23);
                }, matchValue_4.fields[0]), react.createElement("div", {
                    className: "network-details",
                }, ...children_29)));
                break;
            }
            default: {
                bodyHtml = info(props.GetTranslation("Common.WaitingToLoad").split(""));
            }
        }
        networkDetailsModalHtml = modal(true, getModalContainer(new ModalSize(3), react.createElement(react.Fragment, {}, headerHtml, bodyHtml, footerHtml)));
    }
    let netStatusDetailsButtonsHtml;
    const children_45 = [(children_37 = [(children_33 = [getMaterialIcon("refresh")], react.createElement("span", {
        className: "d-flex",
    }, ...children_33)), (children_35 = [props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Order.UpdateNetStatus")], react.createElement("span", {
        className: "d-flex ml-1",
        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Order.UpdateNetStatus",
    }, ...children_35))], react.createElement("div", {
        id: "order-update-network-status",
        className: "actions__action",
        onClick: (_arg_6) => {
            const matchValue_5 = map((x_1) => x_1.NumberFrom, props.SelectedNumberHistory);
            if (matchValue_5 == null) {
            }
            else {
                props.UpdateNetworkStatusFn(matchValue_5);
            }
        },
    }, ...children_37)), (children_43 = [(children_39 = [getMaterialIcon("sensors")], react.createElement("span", {
        className: "d-flex",
    }, ...children_39)), (children_41 = [props.GetTranslation("CustomerContract.Invoicee.Subscriptions.Order.ViewNetworkDetails")], react.createElement("span", {
        className: "d-flex ml-1",
        ["data-translation"]: "CustomerContract.Invoicee.Subscriptions.Order.ViewNetworkDetails",
    }, ...children_41))], react.createElement("div", {
        id: "order-view-network-details",
        className: "actions__action",
        onClick: (_arg_7) => {
            startImmediate(singleton.Delay(() => {
                const matchValue = networkDetailsState[0];
                switch (matchValue.tag) {
                    case 2: {
                        return singleton.Zero();
                    }
                    case 0:
                    case 3: {
                        const matchValue_1 = props.SelectedNumberHistory;
                        if (matchValue_1 != null) {
                            const number = matchValue_1;
                            networkDetailsState[1](new LoadState$2(1));
                            return singleton.Bind(loadNetworkDetails_1(props.GlobalDependencies.ClientNr, props.ContractNr, number.NumberFrom), (_arg) => {
                                const result = _arg;
                                const arg = (result.tag === 0) ? (new LoadState$2(2, map_1((tupledArg) => [tupledArg[0], map_1((d_1) => (new NetworkDetails(d_1.description, d_1.name, d_1.value)), tupledArg[1])], List_groupBy((d) => d.category, result.fields[0], {
                                    Equals: (x, y) => (x === y),
                                    GetHashCode: stringHash,
                                })))) : (new LoadState$2(3, result.fields[0]));
                                networkDetailsState[1](arg);
                                return singleton.Zero();
                            });
                        }
                        else {
                            return singleton.Zero();
                        }
                    }
                    default: {
                        return singleton.Zero();
                    }
                }
            }));
            networkDetailsModalOpenState[1](true);
        },
    }, ...children_43))];
    netStatusDetailsButtonsHtml = react.createElement("div", {
        className: "pending-requests__actions",
    }, ...children_45);
    let headingAndTableHtml;
    const requestsHtml = renderHeadingAndTable(new RenderHeadingAndTableProps(props.Orders, props.Locale, (orderNr) => {
        startImmediate(singleton.Delay(() => {
            cancelOrderStatusState[1](new SaveStatus(1));
            const matchValue_2 = props.NetworkContractNr;
            if (matchValue_2 != null) {
                const networkContractNr = matchValue_2 | 0;
                return singleton.Bind(cancelOrder_1(props.GlobalDependencies.ClientNr, networkContractNr, orderNr), (_arg_1) => {
                    const result_1 = _arg_1;
                    const arg_2 = (result_1.tag === 0) ? (new SaveStatus(2)) : (new SaveStatus(3, result_1.fields[0]));
                    cancelOrderStatusState[1](arg_2);
                    props.ReloadOrdersFn();
                    return singleton.Zero();
                });
            }
            else {
                return singleton.Zero();
            }
        }));
    }, () => {
        cancelOrderStatusState[1](new SaveStatus(0));
    }, props.GlobalDependencies.ClientNr, props.NetworkContractNr, props.ContractNr, map((nh) => nh.NumberFrom, props.SelectedNumberHistory), cancelOrderStatusState[0], props.ReloadOrdersFn, () => {
        logii("LoadOperationStatuses");
    }, () => {
        pendingProvisioningEventsState[1](new LoadState$2(1));
        startImmediate(singleton.Delay(() => singleton.Bind(loadPendingProvisioningEvents_1(props.GlobalDependencies.ClientNr, props.ContractNr), (_arg_2) => {
            const result_2 = _arg_2;
            const arg_4 = (result_2.tag === 0) ? (new LoadState$2(2, result_2.fields[0])) : (new LoadState$2(3, result_2.fields[0]));
            pendingProvisioningEventsState[1](arg_4);
            return singleton.Zero();
        })));
    }, pendingProvisioningEventsState[0], () => {
        pendingProvisioningEventsState[1](new LoadState$2(0));
    }, saveArchiveOrder, cancelOrder_1, createOrder, updatePendingChangeDate));
    headingAndTableHtml = react.createElement("div", {
        className: "fit-content order-table",
    }, requestsHtml);
    let errorModalHtml;
    const matchValue_6 = updateNetworkStatusState[0];
    errorModalHtml = ((matchValue_6.tag === 3) ? renderAsModal("Error", (children_49 = [stripHtmlTags(matchValue_6.fields[0].split(""))], react.createElement("div", {}, ...children_49)), new MessageType(2), props.GetTranslation("Common.Close"), (_arg_8) => {
        updateNetworkStatusState[1](new SaveStatus(0));
    }) : react.createElement(react.Fragment, {}));
    return react.createElement("div", {
        className: "pending-requests",
    }, netStatusDetailsButtonsHtml, headingAndTableHtml, errorModalHtml, networkDetailsModalHtml);
}, "PlacedOrdersSection", uncurry(2, void 0), void 0, "renderPlacedOrdersSection", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Telecom\\PendingOrders.fs", 1203);

